import {
  ChatbotCriteria,
  ChatbotType,
  PageRequest,
  PaginationResponseType,
  ResponseType
} from '@types';
import { axios, get, post, put } from './baseAxios';
import { API_CHATBOT } from './urls';

const url = API_CHATBOT;

const create = (request: ChatbotType): Promise<ResponseType<ChatbotType>> =>
  post(`${url}`, request);

const update = (id: number, request: ChatbotType): Promise<ResponseType<ChatbotType>> =>
  put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<ResponseType<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<ResponseType<ChatbotType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & ChatbotCriteria
): Promise<PaginationResponseType<ChatbotType[]>> => get(`${url}`, { params: { ...request } });

export { create, deleteById, filter, getById, update };

